<template>
  <RoamingTeamTable />
</template>

<script>
import RoamingTeamTable from "@/components/roamingTeam/RoamingTeamTable.vue";

export default {
  name: 'RoamingTeamView',
  components: {RoamingTeamTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
